import { connect } from 'react-redux';

import { actions as pinsActions } from 'modules/pins';

import Marker from '../components/Marker';

const { setNewPin, dragPin } = pinsActions;

export default connect(null, (dispatch, { id }) => ({
    onDragEnd: e => {
        const payload = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng(),
        };
        if (!id) {
            dispatch(setNewPin(payload));
        } else {
            dispatch(dragPin(id, payload));
        }
    },
}))(Marker);
